import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ButtonForm() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <button type="submit" className="btn btn__form">
      {location.pathname === '/login' ? 'Log In' : 'Register'}
    </button>
  );
}

export default ButtonForm;
